import { render } from "./CompletarFormulario.vue?vue&type=template&id=8fa821be&scoped=true"
import script from "./CompletarFormulario.vue?vue&type=script&lang=js"
export * from "./CompletarFormulario.vue?vue&type=script&lang=js"

import "./CompletarFormulario.vue?vue&type=style&index=0&id=8fa821be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fa821be"]])

export default __exports__